import { types } from '../../types/types'
import moment from "moment";
import AfiliadoService from '../../services/AfiliadoService'
import { startAlerta } from '../ui/alertas'
import { finishSpinner, startSpinner } from '../ui/spinner'


export const enviarSeguimiento = (observacion,fechaAviso,seguimiento) => 
  async (dispatch, getState) => {
    try {
        
        dispatch(startSpinner())
        const { afiliado } = getState().afiliacion;
        let fc = moment(fechaAviso).toDate()
        let fecha = new Date(Date.UTC(fc.getFullYear(), fc.getMonth(), fc.getDate(), fc.getHours(), fc.getMinutes(), fc.getSeconds()));
        let result= await AfiliadoService.ingresarSeguimiento({idAfiliado:afiliado.id_afiliado, fechaAviso:fecha, observacionSeguimiento:observacion,seguimiento:seguimiento})
          const body = await result.json()
          if (result.ok) {
            dispatch({
              type: types.afiliacionesActualizarSeguimiento,
              payload: true
          })
            dispatch(finishSpinner())
            dispatch(startAlerta(`Seguimiento Ingresado`,'success','Comando Exitoso'))
          } else {
            throw body.errores
          }
       // alert(afiliado.id_afiliado);
        //alert(observacion);
        dispatch(finishSpinner());
    } catch (error) {
        dispatch(finishSpinner())
        if (error && error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}

export const enviarReclamoSSSalud = (observacion,fechaAviso,reclamoSSSalud) => 
  async (dispatch, getState) => {
    try {
        
        dispatch(startSpinner())
        const { afiliado } = getState().afiliacion;
        let fc = moment(fechaAviso).toDate()
        let fecha = new Date(Date.UTC(fc.getFullYear(), fc.getMonth(), fc.getDate(), fc.getHours(), fc.getMinutes(), fc.getSeconds()));
        let result= await AfiliadoService.ingresarReclamoSSSalud({idAfiliado:afiliado.id_afiliado, fechaAviso:fecha, observacionReclamoSSSalud:observacion,reclamoSSSalud:reclamoSSSalud})
          const body = await result.json()
          if (result.ok) {
            dispatch({
              type: types.afiliacionesActualizarReclamoSSSalud,
              payload: true
          })
            dispatch(finishSpinner())
            dispatch(startAlerta(`Reclamo SSSalud Ingresado`,'success','Comando Exitoso'))
          } else {
            throw body.errores
          }
       // alert(afiliado.id_afiliado);
        //alert(observacion);
        dispatch(finishSpinner());
    } catch (error) {
        dispatch(finishSpinner())
        if (error && error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}